import { config } from "../../config";
import { getAssetPath } from "../../utils/assetsUtils";
import {
  redirectToLivePage,
  redirectToLiveRecordingPage,
  redirectToFacebookLivePage,
} from "../../utils/pageRedirect";
import { isUserCourseOnwer } from "../../utils/user";
import * as DomestikaLiveTypes from "../../constants/domestikaLiveTypes";
import * as LiveSessionStates from "../../constants/liveSessionStates";

export const defaultStreamer = {
  name: config.DEFAULT_DOMESTIKA_STREAMER_NAME,
  avatar: getAssetPath(config.DEFAULT_DOMESTIKA_STREAMER_AVATAR),
};

export const mapTeacher = ({ name, avatar }) => ({
  name,
  avatar: getAssetPath(avatar.url),
});

export const isTeacher = (course, user) => isUserCourseOnwer(course, user);

export const liveRedirect = {
  [DomestikaLiveTypes.FACEBOOK_LIVE]: (id) => redirectToFacebookLivePage(id),
  [DomestikaLiveTypes.DOMESTIKA_LIVE]: (liveSessionId, courseId, state) => {
    if (state === LiveSessionStates.FINISHED) {
      redirectToLiveRecordingPage(courseId, liveSessionId);
    } else {
      redirectToLivePage(courseId, liveSessionId);
    }
  },
};
